'use strict';

import $ from 'jquery';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import tabs from './tabs';

//import hyphenopoly from "hyphenopoly";

window.jQuery = $;

$(function() {
    tabs.initAccordionTab();
    if(!sessionStorage['grayscale']) {
        var grayscale = "false";
        sessionStorage['grayscale'] = grayscale;
    } else {
        var grayscale = sessionStorage['grayscale'];
    }

    if(!sessionStorage['textSize']) {
        var textSize = "1";
        sessionStorage['textSize'] = textSize;
    } else {
        var textSize = sessionStorage['textSize'];
    }

    if(grayscale == "false") {
        $('body').removeClass('grayscale');
    } else if(grayscale == "true") {
        $('body').addClass('grayscale');
    }

    if(textSize) {
        $('body').removeClass('text-size-1 text-size-2 text-size-3').addClass('text-size-' + textSize);
    }

    $('.grayscale-toggle').click(function(e) {
        e.preventDefault();

        if(grayscale == "true") {
            grayscale = "false";
        } else if(grayscale == "false") {
            grayscale = "true";
        }
        sessionStorage['grayscale'] = grayscale;

        $('body').toggleClass('grayscale');
    });

    $('.text-size-toggle').click(function(e) {
        e.preventDefault();

        sessionStorage['textSize'] = $(this).data('size');
        $('body').removeClass('text-size-1 text-size-2 text-size-3').addClass('text-size-' + $(this).data('size'));

    });

    $('.to-top').click(function() {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    });

    $('video').each(function(){
        let video = $(this);
        let src = $(this).find('source').attr('src');
        let poster = src.substring(0, src.lastIndexOf('.'));
        poster = poster + '.jpg'
        
        $.get(poster)
            .done(function() { 
                video.attr('poster', poster);
            }).fail(function() { 
                console.log('Poster für Video existiert nicht');
            });

    });

    $('.menu-button').click(function(){
        $(this).next('ul').fadeToggle(500);
    })

    if(window.innerWidth >=1020 ){

        // close sub-menu per click on other point
        $(document).on('click', function(event) {
            if (!$(event.target).closest('.sub-nav').length && !$(event.target).closest('nav').length) {
                $('.sub_nav').removeClass('show');
                $('.triangle').removeClass('show');
                $('nav >ul >li').each(function(){
                    $(this).removeClass('active');
                });
            }
        });

        // add class parent for arrow->subnav
        $('nav ul li').each(function(){
            if( $(this).find('ul').length > 0 ){
                $(this).addClass('parent');
            }
        });

        var checkNode1 = false;
        var checkNode2 = false;
        var checkNode3 = false;
        var checkNode4 = false;

        function calcSubNavPos(e) {
            let documentWidht = $(document).width();
            let navigationWidth = $('.wrapper.navigation').outerWidth();
            let subNavWidth = $('.sub_nav').outerWidth();
            let triangleWidth = $('.sub_nav .triangle').outerWidth();
            // let difference = parseInt((documentWidht - navigationWidth + triangleWidth) / 2);
            // let posLeft = e.pageX - difference;
            let posLeft = parseInt((subNavWidth - triangleWidth) / 2 )
            let posLeftSub = e.pageX - parseInt((documentWidht - navigationWidth + subNavWidth) / 2);

            // $('.sub_nav .triangle').css({ 'left': posLeft + 'px' });
            $('.sub_nav').css({ 'left': posLeftSub + 'px' });
        }

        function checkSubNavPos() {
            let documentWidth = $(document).width();
            let navigationWidth = $('.wrapper.navigation').outerWidth();
            let subNavWidth = $('.sub_nav').outerWidth();
            let position = $('.sub_nav').position();
            let spaceLeft = 0;

            if(documentWidth > navigationWidth) {
                spaceLeft =  -Math.abs(parseInt( (documentWidth - navigationWidth) / 2));
            }

            // if( position.left < spaceLeft ){
            //     console.log('LEFT');
            //     $('.sub_nav').css({ 'left': spaceLeft + 'px' });
            // }

            if( (position.left + subNavWidth + ( Math.abs(spaceLeft) * 2) ) > documentWidth ){
                $('.sub_nav').css({ 'left': 'unset', 'right': (spaceLeft + 20) + 'px'  });
            }
        }

        // Navigation -> put + remove Elements in sub-menu 
        $('nav >ul >li a').mouseenter(function(e) {
            // triangle
            
            let xy = $( this ).offset();

            let $triangle = $('.triangle');
            let wh = $triangle.outerWidth();

            $triangle.css({
                top: xy.top + $(this).outerHeight() - wh / 2,
                left: xy.left + $(this).outerWidth() / 2 - wh / 2
            });
            
            $('nav >ul >li').each(function(){
                $(this).removeClass('active');
            });

            let parent = $(this).parent();
            
            // setTimeout(function(){
                parent.addClass('active');
            // }, 770);

            let contentNode = $(this).parent().find('ul').html();
            if (contentNode) {
                e.preventDefault();

                $('.sub_nav').removeClass('max-width2 max-width3 max-width4').addClass('max-width1');
                
                $('.node1').fadeOut().delay(0).queue(function(next) {
                    $(this).html('<ul>' + contentNode + '</ul>').fadeIn()
                    next();
                });

                $('.node2, .node3, .node4').html('').fadeOut();
                $('.node2, .node3, .node4').removeClass('border');

                $(".sub_nav").removeClass("show").delay(0).queue(function(next) {
                    $(this).addClass("show");
                    next();
                });

                $(".triangle").removeClass("show").delay(0).queue(function(next) {
                    $(this).addClass("show");
                    next();
                });

                setTimeout(function(){
                    calcSubNavPos(e);
                    checkSubNavPos();
                }, 0);


                checkNode2 = false;
                checkNode3 = false;
                checkNode4 = false;

            }
        });
        // mouseleave(function(e) {
        //     let parent = $(this).parent();
        //     parent.removeClass('active');
        // });

        $('nav .node1').on('click', 'ul >li >a', function(e) {
            let contentNode = $(this).parent().find('ul').html();
            if (contentNode) {
                e.preventDefault();

                $('.sub_nav').removeClass('max-width1 max-width3 max-width4').addClass('max-width2');
                
                $('.node2').fadeOut().delay(750).queue(function(next) {
                    $(this).html('<ul>' + contentNode + '</ul>').fadeIn()
                    next();
                });

                $('.node2').addClass('border');
                $('.node3, .node4').html('').fadeOut();
                $('.node3, .node4').removeClass('border');

                $(this).parent().parent().find('.active').removeClass('active');
                $(this).parent().addClass('active');

                if(checkNode2 == false) {

                    setTimeout(function(){
                        let nodeWidth = $('.sub_nav .node2').outerWidth();
                        let position = $('.sub_nav').position();
                        $('.sub_nav').css({ 'left': (position.left - parseInt(nodeWidth / 2) ) + 'px' });
                    }, 800);
                    checkNode2 = true;

                }

                if(checkNode3 == true && checkNode4 == false) {
                    let position = $('.sub_nav').position();
                    let nodeWidth = parseInt($('.wrapper.navigation').outerWidth() * 0.25 );
                    $('.sub_nav').css({ 'left': (position.left + parseInt(nodeWidth / 2) ) + 'px' });
                }

                if(checkNode3 == true && checkNode4 == true) {
                    let position = $('.sub_nav').position();
                    let nodeWidth = parseInt($('.wrapper.navigation').outerWidth() * 0.5 );
                    $('.sub_nav').css({ 'left': (position.left + parseInt(nodeWidth / 2) ) + 'px' });
                }

                setTimeout(function(){
                    checkSubNavPos();
                }, 1500);

                checkNode3 = false;
                checkNode4 = false;

            }
        });

        $('nav .node2').on('click', 'ul >li >a', function(e) {
            let contentNode = $(this).parent().find('ul').html();
            if (contentNode) {
                e.preventDefault();

                $('.sub_nav').removeClass('max-width1 max-width2 max-width4').addClass('max-width3');
                
                $('.node3').fadeOut().delay(750).queue(function(next) {
                    $(this).html('<ul>' + contentNode + '</ul>').fadeIn()
                    next();
                });

                $('.node3').addClass('border');
                $('.node4').html('').fadeOut();
                $('.node4').removeClass('border');
                $(this).parent().parent().find('.active').removeClass('active');
                $(this).parent().addClass('active');

                if(checkNode3 == false) {

                    setTimeout(function(){
                        let nodeWidth = $('.sub_nav .node3').outerWidth();
                        let position = $('.sub_nav').position();
                        $('.sub_nav').css({ 'left': (position.left - parseInt(nodeWidth / 2) ) + 'px' });
                    }, 800);
                    checkNode3 = true;

                }

                if(checkNode4 == true) {
                    let position = $('.sub_nav').position();
                    let nodeWidth = parseInt($('.wrapper.navigation').outerWidth() * 0.25 );
                    $('.sub_nav').css({ 'left': (position.left + parseInt(nodeWidth / 2) ) + 'px' });
                }

                setTimeout(function(){
                    checkSubNavPos();
                }, 1500);

                checkNode4 = false;

            }
        });

        $('nav .node3').on('click', 'ul >li >a', function(e) {
            let contentNode = $(this).parent().find('ul').html();
            if (contentNode) {
                e.preventDefault();

                $('.sub_nav').removeClass('max-width1 max-width2 max-width3').addClass('max-width4');
                
                $('.node4').fadeOut().delay(750).queue(function(next) {
                    $(this).html('<ul>' + contentNode + '</ul>').fadeIn()
                    next();
                });

                $('.node4').addClass('border');
                $(this).parent().parent().find('.active').removeClass('active');
                $(this).parent().addClass('active');

                if(checkNode4 == false) {
                    
                    setTimeout(function(){
                        let nodeWidth = $('.sub_nav .node4').outerWidth();
                        let position = $('.sub_nav').position();
                        $('.sub_nav').css({ 'left': (position.left - parseInt(nodeWidth / 2) ) + 'px' });
                    }, 800);
                    checkNode4 = true;

                }

                setTimeout(function(){
                    checkSubNavPos();
                }, 1500);

            }
        });

    } else {

         // add class parent for arrow->subnav
        $('nav ul li').each(function(){
            if( $(this).find('ul').length > 0 ){
                $(this).addClass('parent');
            }
        });

        // Navigation -> put + remove Elements in sub-menu 
        $('nav ul li a').click(function(e) {

            $('nav >ul >li').each(function(){
                $(this).removeClass('active');
            });

            $(this).parent().addClass('active');

            let contentNode = $(this).next('ul');
            // console.log(contentNode);
            if (contentNode.length > 0) {
                console.log('click: e.preventDefault');
                e.preventDefault();
                contentNode.fadeToggle(500);
            }
        });

    }


    var border1 = $(".top-bar").outerHeight();
    var topBar = $(".top-bar");
    var navigation = $(".navigation");
    var navigationLogo = $(".navigation .logo");
    var breadcrumb = $(".breadcrumb");
    var toTop = $('.to-top');

    $(window).scroll(function() {

        if ($(window).scrollTop() >= border1) {
            topBar.addClass('nav-fixed');
            navigation.addClass('fixed');
            navigationLogo.addClass('show');
            breadcrumb.addClass('fixed');

        }
        if ($(window).scrollTop() < border1) {
            topBar.removeClass('nav-fixed');
            navigation.removeClass('fixed');
            navigationLogo.removeClass('show');
            breadcrumb.removeClass('fixed');
        }

        let top = $(document).scrollTop();
        let res = top > 100;
        toTop.toggleClass('show', res);

    });

    let maxHeight = -1;
    let boxTitleSelector = '.tiles .item-wrapper .item h3';

    $(boxTitleSelector).each(function() {
        let height = $(this).outerHeight();
        if (height > maxHeight || maxHeight == -1) {
            maxHeight = height;
        }
    });

    $(boxTitleSelector).css('height', maxHeight + 'px');

    let boxTitleSelectorH2 = '.cols3.tiles .wrapper .ce-bodytext h2';

    $(boxTitleSelectorH2).each(function() {
        let height = $(this).outerHeight();
        if (height > maxHeight || maxHeight == -1) {
            maxHeight = height;
        }
    });

    $(boxTitleSelectorH2).css('height', maxHeight + 'px');

    $(' a.back ').click(function(e){
        e.preventDefault();
        history.back(1);
    });

    // Accordion-Menu
    // $('.acc_title').click(function() {
    //     $(this).next().stop().slideToggle(700);
    //     $(this).toggleClass('active');
    // });

    // $('.acc-li')
    // .on('mouseenter', function() {
    //     let children = $(this).children();
    //     console.log(children);
    //
    //     $(children[0]).addClass('acc-selected');
    //     $(children[1]).slideDown(700);
    // })
    // .on('mouseleave', function() {
    //     let children = $(this).children();
    //
    //     $(children[0]).removeClass('acc-selected');
    //     $(children[1]).slideUp(700);
    // });


    // Auskommentiert am 08.04.21 -> stört bei About us -> Aepartments -> System Architectures -> Technical Basis
    // let maxImageHeight = -1;
    // let boxImageSelector = '.technical-basis .ce-gallery .ce-column .image img';

    // $(boxImageSelector).each(function() {
    //     let height = $(this).outerHeight();
    //     if (height > maxHeight || maxHeight == -1) {
    //         maxHeight = height;
    //     }
    // });

    // $(boxImageSelector).each(function() {
    //     let height = $(this).outerHeight();
    //     if (height < maxHeight) {
    //         let padding = maxHeight - height;
    //         $(this).css({ 'padding-bottom' : '' + padding + 'px' });
    //     }
    // });




    // $('div:not(.frame-layout-1) .tinyaccordion li h4').click(function(){
    //     $(this).next('.acc-section').stop().slideToggle(700);
    //     $(this).toggleClass('acc-selected');
    // });
    //
    $(".frame-layout-1 .tx-tinyaccordion-pi1 .tinyaccordion li").on('mouseenter',function(event) {
        if(event.clientX < ($(window).width()/2)) {
            var leftPos = event.clientX
        } else {
            var leftPos = event.clientX - 500;
        }
        $(this).find('.acc-section').css({top: event.clientY, left: leftPos, height:'auto'}).stop().show(750);
    })
    .on('mousemove',function(event){
        if(event.clientX < ($(window).width()/2)) {
            var leftPos = event.clientX
        } else {
            var leftPos = event.clientX - 500;
        }
        $(this).find('.acc-section').css({top: event.clientY, left: leftPos});
    })
    .on('mouseleave', function() {
        $(this).find('.acc-section').stop().hide(750);
    });

    // Nur für Mobile aktivieren
    // $('.frame-layout-1 .tinyaccordion li h4').click(function(){
    //     $(this).next('.acc-section').css({'pointer-events': 'all', 'cursor':'pointer' });
    //     $(this).next('.acc-section').stop().animate({
    //         opacity: 1
    //     },500);
    // });

    // $('.frame-layout-1 .tinyaccordion li .acc-section').click(function(){
    //     $(this).css({'pointer-events': 'none'});
    //     $(this).stop().animate({
    //         opacity: 0
    //     },500);
    // });

    setTimeout(() => {

        // Tabs (Persons)
        $('.contact_persons .tab').click(function() {
            let target = $(this).data('target');
            let beforeActive = $(this).parent().parent().find('.active');
            beforeActive.removeClass('active');
            let currentActive = $(this).parent().parent().find('.' + target);
            currentActive.addClass('active');
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
        });

        $('.contact_persons2 .tab').click(function() {
            let target = $(this).data('target');
            let beforeActive = $(this).parent().parent().find('.active');
            beforeActive.removeClass('active');
            let currentActive = $(this).parent().parent().find('.' + target);
            currentActive.addClass('active');
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
        });

        $('.content_tabs .wrapper .tab_wrapper .tab').click(function() {
            let target = $(this).data('target');
            let beforeActive = $(this).parent().parent().find('.active');
            beforeActive.removeClass('active');
            let currentActive = $(this).parent().parent().find('.' + target);
            currentActive.addClass('active');
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
        });
        
    }, 500);

    var tabIndex = 0;
    var tabActive = "";
    $('.contact_persons .frame-type-textpic').each(function(){
        tabIndex+=1;
        
        if(tabIndex == 1) {
            tabActive = 'active';
        } else {
            tabActive = '';
        }

        $( this ).addClass('item element-' + tabIndex + ' ' + tabActive);

        let tab = $(this).find('header h2').html();
        $('.contact_persons .tab_wrapper').append( '<div class="tab ' + tabActive + '" data-target="element-' + tabIndex + '"><p>' + tab + '</p></div>' );

    });

    var tabIndex2 = 0;
    var tabActive2 = "";
    $('.contact_persons2 .frame-type-textpic').each(function(){
        tabIndex2+=1;
        
        if(tabIndex2 == 1) {
            tabActive2 = 'active';
        } else {
            tabActive2 = '';
        }

        $( this ).addClass('item element-' + tabIndex2 + ' ' + tabActive2);

        let tab2 = $(this).find('header h2').html();
        $('.contact_persons2 .tab_wrapper').append( '<div class="tab ' + tabActive2 + '" data-target="element-' + tabIndex2 + '"><p>' + tab2 + '</p></div>' );

    });


    var tabIndex3 = 0;
    var tabActive3 = "";
    $('.content_tabs .wrapper .frame-type-news_newsdetail .news-single .article .frame-layout-0').each(function(){
        tabIndex3+=1;
        
        if(tabIndex3 == 1) {
            tabActive3 = 'active';
        } else {
            tabActive3 = '';
        }

        let tab3 = $(this).find('header h2').html();
        if (tab3) {
            $(this).addClass('item element-' + tabIndex3 + ' ' + tabActive3);
            $('.content_tabs .wrapper .tab_wrapper').append( '<div class="tab ' + tabActive3 + '" data-target="element-' + tabIndex3 + '"><p>' + tab3 + '</p></div>' );
        } else {
            console.log('Jup, leerer Header');
            console.log($(this));
            $(this).addClass('item element-' + (tabIndex3 - 1) + ' ' + ((tabIndex3 - 1) == 1 ? 'active' : ''));
        }

        let newsTitle = $('.news-single .article h1');
        let categoryList = $('.news-single .article .info');
        let tabWrapper = $('.content_tabs .wrapper .tab_wrapper');

        newsTitle.insertBefore(tabWrapper);
        categoryList.insertBefore(tabWrapper);

    });


    var slidesSlider = new Swiper('.tiles_slider', {
        modules: [Autoplay, Navigation, Pagination ],
        direction: 'horizontal',
        autoplay: true,
        slidesPerView: 3,
        speed: 750,
        spaceBetween: 40,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: 'true',
            bulletClass: 'bar',
            bulletActiveClass: 'bar-active',
        },

    });

    $('.persons_slider .swiper-wrapper > div').addClass('swiper-slide');

    var personSlider = new Swiper('.persons_slider', {
        // init: false,
        // loop: true,
        // speed:800,
        // slidesPerView: 2, // or 'auto'
        // centeredSlides : true,
        // effect: 'coverflow', // 'cube', 'fade', 'coverflow',
        // coverflowEffect: {
        //     rotate: 50, // Slide rotate in degrees
        //     depth: 0, // Depth offset in px (slides translate in Z axis)
        //     modifier: 1, // Effect multipler
        //     slideShadows : true, // Enables slides shadows
        // },
        // parallax: true,
        modules: [Autoplay, Navigation, Pagination, EffectCoverflow ],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 2.1,
        speed: 1000,
        centeredSlides: false,
        autoplay: {
            delay: 2500,
        },
        effect: 'coverflow', // 'cube', 'fade', 'coverflow',
        coverflowEffect: {
            rotate: -35, // Slide rotate in degrees
            depth: 0, // Depth offset in px (slides translate in Z axis)
            modifier: 1, // Effect multipler
            slideShadows : false, // Enables slides shadows
            stretch: 30,
        },
        parallax: true,

        breakpoints: {
			1020: {
                slidesPerView: 2.1,
            },
            800: {
                slidesPerView: 3.5,
            },
            680: {
                slidesPerView: 1.2,
            },
            500: {
                slidesPerView: 1.3,
            },
            300: {
                slidesPerView: 1.0,
            }
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: 'true',
            bulletClass: 'bar',
            bulletActiveClass: 'bar-active',
        },

    });

    $('.carousel .ce-gallery').removeClass('ce-gallery').addClass('div1');
    $('.carousel >div .ce-outer').removeClass('ce-outer').addClass('div2');
    $('.carousel >div >div .ce-inner').removeClass('ce-inner').addClass('div3');
    $('.carousel >div >div >div .ce-row').removeClass('ce-row').addClass('div4');

    let carouselWrapper = $('.carousel .div1 .div2 .div3 .div4');
    carouselWrapper.addClass('swiper-wrapper');
    carouselWrapper.find('.ce-column').removeClass('ce-column').addClass('swiper-slide');

    var carousel = new Swiper('.carousel .div1 .div2 .div3', {
        modules: [Autoplay, Navigation, Pagination ],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        speed: 1000,
        centeredSlides: false,
        autoplay: {
            delay: 2500,
        },

        breakpoints: {
            1000: {
                slidesPerView: 3,
            },
			800: {
                slidesPerView: 2,
            },
            500: {
                slidesPerView: 1,
            },
            300: {
                slidesPerView: 1,
            },
        },

        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },

    });

    let carouselContactWrapper = $('.carousel-contact');
    carouselContactWrapper.find('.frame').addClass('swiper-slide');
    var carouselContact = new Swiper('.carousel-contact', {
        modules: [Autoplay, Navigation, Pagination ],
        direction: 'horizontal',
        loop: true,
        slidesPerView: 4,
        speed: 1000,
        autoplay: {
            delay: 2500,
        },

        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },

    });


    var $animation_elements = $('.animation-element');
    var $window = $(window);

    function check_if_in_view() {
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);

        $.each($animation_elements, function() {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);

            //check to see if this current container is within viewport
            if ((element_bottom_position >= window_top_position) &&
                (element_top_position <= window_bottom_position)) {
                $element.addClass('in-view');
            } else {
                $element.removeClass('in-view');
            }
        });
    }

    $window.on('scroll resize', check_if_in_view);
    $window.trigger('scroll');

    if( !$('body').hasClass('pid-1')){
        setTimeout(() => {
            let posToElement =  $("main").offset().top - $('header .navigation').outerHeight();
            if($(window).scrollTop() < posToElement){
                $('html, body').animate({
                    scrollTop: posToElement
                }, 1000);
            }
        }, 2000);
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    function replaceUrlParam(url, paramName, paramValue)
    {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
        if (url.search(pattern)>=0) {
            return url.replace(pattern,'$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/,'');
        return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }

    if( $('html')[0].lang == "de-de" ){
        var iframeLang = "de";
    } else {
        var iframeLang = "en";
    }

    if (getUrlParameter('job')){
        var newjobID = getUrlParameter('job');
    } else {
        if(iframeLang=="de") {
            var newjobID = "Unsolicited_Application";
        } else {
            var newjobID = "Unsolicited_Application";
        }
    }

    let iframe = '<iframe id="jobiframe" class="jobframe" height="498" src="https://www.ihp-microelectronics.com/rcs/index.php?job=' + newjobID + '&amp;lang=' + iframeLang + '"></iframe>';
    $('div.jobwrapper').html( iframe );

    $('.above_box_gray .jobwrapper').css({ 'display':'none' });

    let changeFormDomain = function(){ 
        let form = $('.news-single .frame-type-form_formframework form');
        let formWrapper = $('.news-single .frame-type-form_formframework >div');
        
        if(form.length > 0) {
            let formAction = form.attr('action');
            let pathname = window.location.pathname;
            let query = formAction.split("?");
            let newPath = pathname + "?" + query[1];
            form.attr('action',newPath);
            console.log(newPath);
        } 
        
        if(formWrapper.length > 0) {
            console.log('Ja Wrapper und Nein Form');
            // formWrapper.addClass('fixedMessage');
            // formWrapper.append('<div class="close">&times</div>');
            // formWrapper.find('.close').click(function(){
                //     formWrapper.hide(300);
                // });
            formWrapper.parent().addClass('active');
            $('.article .item.element-1').removeClass('active');
            $('.tab_wrapper .tab').removeClass('active');
        }

    }
    
    changeFormDomain();

    $('.close-notice').click(function(){
        $(this).parent().remove();
    });
    
});

let options = {};
var lang = document.querySelectorAll("html")[0].getAttribute("lang");

// var categoryButtonAll = '<li><a class="button" title="' + buttonAllTitle + '" href="/">' + buttonAllValue + '</a></li>';

// $('.news .categies-menu').append('<li>Test</li>');
// console.log( $('.news .categies-menu') );

switch (lang) {
    case 'de-de':
        options["de-de"] = "Silbentrennungsalgorithmus";
        break;
    case 'en-us':
        options["en-us"] = "Supercalifragilisticexpialidocious";
        break;
    case 'en-gb':
        options["en-gb"] = "Supercalifragilisticexpialidocious";
        break;
}

// console.log(options);

//const Hyphenopoly = hyphenopoly.config({
//    require: options,
//    setup: {
//        defaultLanguage: "en-us",
//        selectors: {
//            "main h1": {},
//            "main h2": {},
//            "main h3": {},
//            "main h4": {},
//            "main h5": {},
//            "main p": {},
//            "main li": {},
//            "main figcaption": {}
//        }
//    }
//    );
//};

// console.log(Hyphenopoly);